export default "__VITE_ASSET__CtaozubL__"